import barChartIcon from "../../assets/all-icons/bar-chart-teal.png";
import documentIcon from "../../assets/all-icons/document-clipboard-dark-purple.png";
import digitalIcon from "../../assets/all-icons/folder-document-orange.png";
import gearIcon from "../../assets/all-icons/settings-gear-dark-purple.png";
import { useInView } from "../../hooks/useInView";

const FEATURES = [
  {
    icon: barChartIcon,
    iconBg: "#f0fdfa",
    label: "BORROW WITH CONFIDENCE",
    labelColor: "#2b877f",
    title: "Decisions should feel informed.",
    description:
      "We aim to give you the information you need to evaluate your options and borrow responsibly.",
  },
  {
    icon: documentIcon,
    iconBg: "#faf5ff",
    label: "CLARITY BEFORE COMMITMENT",
    labelColor: "#9333ea",
    title: "Know what you're signing up for.",
    description:
      "We make important loan details, applicable charges, terms and repayment information easy to understand.",
  },
  {
    icon: digitalIcon,
    iconBg: "#fff7ed",
    label: "DIGITAL FROM START TO FINISH",
    labelColor: "#c2410c",
    title: "Your loan journey, wherever you are.",
    description:
      "Explore your options and complete the applicable application steps through a convenient digital experience.",
  },
  {
    icon: gearIcon,
    iconBg: "#faf5ff",
    label: "SIMPLE BY DESIGN",
    labelColor: "#9333ea",
    title: "No unnecessary complexity.",
    description:
      "A straightforward digital journey that helps you understand what you're applying for at every step.",
  },
];

export function WhyChooseUs() {
  const { ref, inView } = useInView<HTMLDivElement>();

  return (
    <section className="w-full bg-white px-4 py-16 sm:py-20">
      <div className="mx-auto flex w-full max-w-[1280px] flex-col gap-10">
        {/* Header row */}
        <div
          ref={ref}
          className={`flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-center ${inView ? "in-view" : ""}`}
        >
          <div className="flex max-w-[500px] flex-col items-start gap-4">
            <span className="reveal-scroll delay-1 rounded-full bg-[#f0edfa] px-4 py-[6px] text-xs font-semibold uppercase tracking-[0.6px] text-brand-purple">
              Why Choose GenzPaisa?
            </span>
            <h2 className="reveal-scroll delay-2 text-3xl font-extrabold leading-tight tracking-[-0.5px] text-[#1c1917] sm:text-4xl">
              More than just loans. A smarter way forward.
            </h2>
          </div>

          <p className="reveal-scroll delay-3 max-w-[420px] text-base leading-6 text-[#475569]">
            From your first click to your final repayment, we keep the loan
            journey simple, clear, and digital — so you can focus on what you
            need, not on navigating complicated processes.
          </p>
        </div>

        {/* 2x2 bento grid */}
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {FEATURES.map((feature) => (
            <div
              key={feature.label}
              className="flex items-start gap-4 rounded-[20px] border border-solid border-[#e2e8f0] bg-white p-6"
            >
              <span
                className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl"
                style={{ backgroundColor: feature.iconBg }}
              >
                <img
                  src={feature.icon}
                  alt=""
                  className="h-6 w-6 object-contain"
                />
              </span>
              <div>
                <p
                  className="text-xs font-semibold uppercase tracking-[0.4px]"
                  style={{ color: feature.labelColor }}
                >
                  {feature.label}
                </p>
                <h3 className="pt-1 text-base font-bold leading-5 text-[#1c1917]">
                  {feature.title}
                </h3>
                <p className="pt-1 text-sm leading-5 text-[#64748b]">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
